export default __webpack_public_path__ + "static/media/mountains.324535bc.svg";